import React, { useState } from "react";
import AddOrUpdateTickets from "./AddOrUpdateTickets";
import SupportTicketsTabs from "./SupportTicketsTabs";
import MUICustomTabs from "src/components/GeneralComponents/MUICustomTabs";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";

function SupportTicket() {
  const [Open, setOpen] = useState("");
  const [tabValue, setTabValue] = useState(1);
  const [drawerState, setDrawerState] = useState(false);
  const [userList, setUserList] = useState([]);

  const handleOpenDrawer = () => {
    setDrawerState(true);
  };

  const handleCloseDrawer = () => {
    setDrawerState(false);
  };

  const handleChanges = (event, newValue) => {
    localStorage.removeItem("support_tickets_data");
    setTabValue(newValue);
  };

  const TABS_OPTIONS = [
    {
      title: `All (${Open.all ? Open.all : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"all"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Waiting (${Open.waiting ? Open.waiting : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"waiting"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Answered (${Open.answered ? Open.answered : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"answered"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Closed (${Open.solved ? Open.solved : 0})`,
      component: (
        <SupportTicketsTabs
          setOpen={setOpen}
          tabValue={tabValue}
          valueData={"solved"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
    {
      title: `Trash (${Open.trash ? Open.trash : 0})`,
      component: (
        <SupportTicketsTabs
          tabValue={tabValue}
          setOpen={setOpen}
          valueData={"trash"}
          setUserList={setUserList}
          userList={userList}
        />
      ),
    },
  ];

  return (
    <div className="container">
      <div className="row mobile-margin display-flex">
        <div className="col-sm-12 col-md-6">
          <h2>Support Tickets</h2>
        </div>

        <div className="col-12">
          <MUICustomTabs
            data={TABS_OPTIONS}
            value={tabValue}
            handleChange={handleChanges}
          />
        </div>
      </div>
      <CustomDrawer
        isOpenDrawer={drawerState}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle="New Ticket"
        componentToPassDown={
          <AddOrUpdateTickets
            formType="ADD"
            onCloseDrawer={handleCloseDrawer}
            setUserList={setUserList}
            setOpen={setOpen}
          />
        }
      />
    </div>
  );
}

export default SupportTicket;
